import { render, staticRenderFns } from "./JykTable.vue?vue&type=template&id=c8c837ba&scoped=true"
import script from "./JykTable.vue?vue&type=script&lang=js"
export * from "./JykTable.vue?vue&type=script&lang=js"
import style0 from "./JykTable.vue?vue&type=style&index=0&id=c8c837ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c837ba",
  null
  
)

export default component.exports